import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';

export default function D({ langKey }: any) {
    const { useLang, Link, gtm } = useGlobal();
    const { t } = useLang(langKey || 'poweroceancollection');

    const cards: any = [
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/4_1.jpg'),
            title: t('secD_list1'),
            // link: '/home-battery/PowerOcean',
            link: 'https://energy.ecoflow.com/de/products/PowerOcean',
        },
        {
            img: require('@publicLocal/power-ocean/collection/pc/de/4_2.jpg'),
            title: t('secD_list2'),
            link: 'https://energy.ecoflow.com/de/products/PowerOcean-DC-Fit',
        },
    ];

    const gotoPage = (link: string, product_name: string, list_name: string, button_name: string) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'select_product',
            product_name,
            list_name,
            button_name,
        });
        window?.open(link);
    };

    return (
        <div className={`power-ocean-collection-D ${css['power-ocean-collection-D']}`}>
            <div className="text-box">
                <p className="title">{t('secD_title')}</p>
                <p className="desc">{t('secD_desc')}</p>
            </div>
            <div className="card-box">
                {cards?.map((card: any, k: number) => (
                    <div key={k} className={`card card${k + 1}`}>
                        <div className="card-img">
                            <NextImage src={card?.img} alt={card?.title} aria-label={card?.title} />
                        </div>
                        <p className="card-title">{card?.title}</p>
                        {/* <Link
                            className="card-btn"
                            href={card?.link}
                            dataLayer={{
                                event: 'uaEvent',
                                event_name: 'select_product',
                                list_name: t('secD_title'),
                                product_name: card?.title,
                                button_name: t('secD_btn'),
                            }}
                        >
                            {t('secD_btn')}
                        </Link> */}
                        <div
                            className="card-btn"
                            // href={card?.link}
                            // dataLayer={{
                            //     event: 'uaEvent',
                            //     event_name: 'select_product',
                            //     list_name: t('secD_title'),
                            //     product_name: card?.title,
                            //     button_name: t('secD_btn'),
                            // }}
                            onClick={() => gotoPage(card?.link, card?.title, t('secD_title'), t('secD_btn'))}
                        >
                            {t('secD_btn')}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
